import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {KeyLogComponent} from './key-log.component';
import {KeyLogFilterComponent} from '../../components/key-log-filter/key-log-filter.component';
import {KeyLogService} from '../../services/key-log.service';
import {KeyLogListComponent} from './key-log-list/key-log-list.component';
import {KeyLogModalComponent} from './key-log-modal/key-log-modal.component';
import {SignOutReturnKeyModalComponent} from './signOutReturnKeyModal/sign-out-return-key-modal.component';
import {KeyLogHistoryComponent} from './key-log-history/key-log-history.component';
import {KeyLogViewComponent} from './key-log-view/key-log-view.component';
import {KeyLogDetailedViewComponent} from './key-log-detailed-view/key-log-detailed-view.component';
import {FieldsModule} from '../../components/fields/fields.module';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        UtilsModule
    ],
    declarations: [
        KeyLogComponent,
        KeyLogListComponent,
        KeyLogFilterComponent,
        KeyLogModalComponent,
        SignOutReturnKeyModalComponent,
        KeyLogHistoryComponent,
        KeyLogViewComponent,
        KeyLogDetailedViewComponent
    ],
    exports: [
        KeyLogModalComponent
    ],
    providers: [
        KeyLogService
    ]
})
export class KeyLogModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log.module.ts